import React, {useState} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import {Box} from '@mui/material';
import './Layout.scss';
import Footer from './footer/Footer';
import HeaderBar from './header/HeaderBar';
import Navbar from '../layout/navbar/Navbar';
import {ReactComponent as ArrLogo} from '../../assets/images/icon-arr.svg';
import {useUserRole} from '../../hooks/users/useUsers';
import RoleImpersonation from '../role-impersonation/RoleImpersonation';

const Layout: React.FC = () => {
  const [sidebarCollapsed] = useState(true);
  useUserRole();
  const {pathname} = useLocation();
  const renderFooter = ![
    '/documentviewer',
    '/documentviewer/docview',
    '/dataanalysisreport/searchtermreport',
    '/ai/investigate',
    '/ai/investigate/manage-indices',
    '/ai/investigate/manage-indices/details',
  ].includes(pathname.toLocaleLowerCase());

  return (
    <div className="app-container" data-testid={`layout-div`}>
      {/* Custom Navbar */}
      <aside className="sidebar" data-testid={`layout-aside`}>
        <nav data-testid={`layout-nav`}>
          <Navbar
            logo={
              <Box className="branding">
                <ArrLogo />
              </Box>
            }
            collapsed={sidebarCollapsed}
            className="dashboard-navbar"
          />
        </nav>
      </aside>
      {/* Main area (Header + Content + Footer) */}
      <div
        className="main-area"
        role="main"
        data-testid={`layout-div-btn`}
        tabIndex={0}
      >
        {/* Header -  Will replace it when we have header a per figma */}
        <header className="header" data-testid={`layout-header`}>
          <HeaderBar />
          <RoleImpersonation />
        </header>

        {/* Content */}
        <main className="content" data-testid={`layout-main`}>
          <Outlet />
        </main>

        {/* Footer */}
        {renderFooter && (
          <footer className="footer" data-testid={`layout-footer`}>
            <Footer />
          </footer>
        )}
      </div>
    </div>
  );
};

export default Layout;
